import React from "react";
import { Outlet } from "react-router-dom";
import { makeStyles } from "@material-ui/core";
import TopBar from "./TopBar";
import getBrandFromUrl from "../../utils/getBrandFromUrl";



const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.default,
    display: "flex",
    overflow: "hidden",
    width: "100%",
  },
  genericRoot: {
    backgroundColor: "#09487f",
    display: "flex",
    overflow: "hidden",
    width: "100%",
    height: "100vh"
  },
  wrapper: {
    display: "flex",
    flex: "1 1 auto",
    overflow: "hidden",
    paddingTop: 61,
  },
  contentContainer: {
    display: "flex",
    flex: "1 1 auto",
    overflow: "hidden",
  },
  content: {
    flex: "1 1 auto",
    overflow: "auto",
  },
}));

const MainLayout = () => {
  const classes = useStyles();
  const brand = getBrandFromUrl();

  return (
    <div className={brand == "Generic"? classes.genericRoot:classes.root} >
      <TopBar />
      <div className={classes.wrapper}>
        <div className={classes.contentContainer}>
          <div className={classes.content}>
            <Outlet />
          </div>
        </div>
      </div>
    </div>
  );
};

export default MainLayout;
